var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatus0 = function SvgStatus0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.5H4.5M5.75 14.5H4.5M5.333 12H3.666M6.697 6.696a7.5 7.5 0 1 1 0 10.607M12 8.25v.757",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.522c.11-.93.942-1.603 1.875-1.515M12 15.75v-.757M13.875 13.478A1.724 1.724 0 0 1 12 14.993M13.827 10.192A1.829 1.829 0 0 0 12 9.008M10.173 13.808A1.829 1.829 0 0 0 12 14.992",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.522v0c0 .641.453 1.193 1.082 1.32l1.586.317a1.345 1.345 0 0 1 1.082 1.319v0",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgStatus0;